import { logger } from '@gem/modules/logger';

import { initUntrustedProject } from 'APP/Tasks/authorization/login/initUntrustedProject';
import * as authModel from 'APP/model/auth/authModel';
import { ILoginSuccess, LoginErrors } from 'APP/model/auth/authModel.types';
import { DeviceStatus } from 'APP/model/userSettings/userSettingsModel.types';
import { RouterLink } from 'APP/router/constants';
import { navigateTo } from 'APP/router/refs/navigateTo';
import { MlsStorageService } from 'SERVICES/mlsStorageService/MlsStorageService';
import { WebCryptoService } from 'SERVICES/webCryptoService/WebCryptoService';
import Entities from 'STORE';

import { getDeviceInfoForLogin } from './getDeviceInfoForLogin';
import { initProject } from './initProject';
import { ILoginResult } from './login.types';

export async function loginByCode(code = ''): Promise<ILoginResult> {
  const device = getDeviceInfoForLogin();

  try {
    const redirectUri = new URL(window.location.origin + window.location.pathname).href;

    const response: ILoginSuccess = await authModel.loginByCode({
      code,
      redirectUri,
      device,
    });

    if (!response.accessToken || !response.user) {
      return { isSuccess: false, error: new Error('401 Unauthorized') };
    }

    let skipE2ee = false;

    if (response.deviceStatus === DeviceStatus.Pending) {
      Entities.authStore.setIsUntrusted(true);
      navigateTo({ to: RouterLink.Untrusted });
      MlsStorageService.clearStorages();
      WebCryptoService.clearStorages();
      const initResult = await initUntrustedProject({
        userId: response.user.id,
        accessToken: response.accessToken,
        deviceKeyPackagesCount: response.deviceKeyPackagesCount,
        refreshToken: response.refreshToken,
      });

      skipE2ee = true;
      if (!initResult.result) {
        throw new Error(LoginErrors.DeviceIsBlocked);
      }
    }

    await initProject(
      {
        refreshToken: response.refreshToken,
        accessToken: response.accessToken,
        user: response.user,
        clientConfig: response.clientConfig,
        deviceKeyPackagesCount: response.deviceKeyPackagesCount,
        deviceStatus: response.deviceStatus,
      },
      undefined,
      undefined,
      skipE2ee
    );

    return { isSuccess: true };
  } catch (error) {
    if (error.message === LoginErrors.DeviceIsBlocked) {
      Entities.authStore.setIsUntrusted(true);
      navigateTo({ to: RouterLink.Blocked });

      return { isSuccess: false, error: new Error('Device is Blocked') };
    }

    logger.get('auth').error('login', error);
    return { isSuccess: false, error };
  }
}

export { refreshToken } from './refreshToken';
